import { styled } from "styled-components";

export const ProductWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
`;
